import React from 'react'
import IcoTelegram from '../icons/IcoTelegram'
import IcoArrow from '../icons/IcoArrow'
import { COMUNIDADE_TELEGRAM } from '../../data/links'
import {
  Sec,
  SecHead,
  SecTitle,
  SecRule,
  Telegram,
  TelegramIcon,
  TelegramBody,
  TelegramTitle,
  TelegramText,
  TelegramBtn
} from './styles'

export default function Comunidade() {
  return (
    <Sec>
      <SecHead>
        <SecTitle className="serif">Comunidade</SecTitle>
        <SecRule />
      </SecHead>
      <Telegram>
        <TelegramIcon>
          <IcoTelegram
            height="32"
            width="32"
          />
        </TelegramIcon>
        <TelegramBody>
          <TelegramTitle className="serif">Comunidade no Telegram</TelegramTitle>
          <TelegramText>
            Converse com outros viajantes-leitores, participe dos clubes de leitura e receba spoilers da curadoria.
          </TelegramText>
        </TelegramBody>
        <TelegramBtn
          href={ COMUNIDADE_TELEGRAM }
          rel="noopener noreferrer"
          target="_blank"
        >
          Entrar no grupo
          <IcoArrow
            height="16"
            width="16"
          />
        </TelegramBtn>
      </Telegram>
    </Sec>
  )
}
